/* eslint-disable react/require-default-props */

import React from 'react'
import PropTypes from 'prop-types'

import ListenToKeyboard from 'components/ListenToKeyboard'
import withMenuPositioning from 'shared/ui/Dropdown/withMenuPositioning'
import { memoize } from 'util/memoization'
import Menu from './Menu'

const calculateOffset = memoize((left, right, top, bottom) => ({
  left,
  right,
  top,
  bottom,
}))

class Dropdown extends React.PureComponent {
  onOpen = () => {
    this.props.onOpen(this.props.ticketId)
  }

  onClose = () => {
    this.props.onClose(this.props.ticketId)
    if (this.props.onModalClose) this.props.onModalClose()
  }

  render() {
    const {
      bottom,
      hotKey, // e.g. 'onM'
      left,
      onOpen,
      onClose,
      open,
      right,
      top,
      trigger,
      ...rest
    } = this.props

    const dynamicProps = hotKey ? { [hotKey]: this.onOpen } : {}

    const offset = calculateOffset(left, right, top, bottom)
    const isOpen = open

    return (
      <div onClick={!isOpen ? this.onOpen : undefined}>
        {!isOpen &&
          hotKey && (
            <ListenToKeyboard
              disableForInput
              preventDefault
              key="keyboard-listener"
              {...dynamicProps}
            />
          )}
        {trigger}
        {isOpen && (
          <Menu
            open={isOpen}
            {...rest}
            onOpen={this.onOpen}
            onClose={this.onClose}
            offset={offset}
          />
        )}
      </div>
    )
  }
}

Dropdown.propTypes = {
  trigger: PropTypes.node.isRequired,
  hotKey: PropTypes.string,
}

export default withMenuPositioning(Dropdown)
